import React, { useEffect, useState } from 'react'

import { Box, CircularProgress } from '@material-ui/core'
import PropTypes from 'prop-types'

import { fetchPortalLink } from 'common/scoir-apply-constants'
import { getProfile } from 'store/application-cycle'
import { useRelevantCycle } from 'store/application-cycle/hooks'

const Page = ({ match }) => {
  const [resolvedYear, setResolvedYear] = useState(0)
  const appCycle = useRelevantCycle()
  const appYear = appCycle || resolvedYear
  useEffect(() => {
    if (appYear > 0) {
      fetchPortalLink(match.params.scid, match.params.applId, appYear).then((url) => {
        window.location.assign(url)
      })
    }
  }, [match.params.scid, match.params.applId, appYear])
  useEffect(() => {
    if (appCycle === 0) {
      getProfile().then((currentYear) => setResolvedYear(currentYear))
    }
  }, [appCycle])

  return (
    <Box
      display="flex"
      justifyContent="center"
      height="100vh"
      alignItems="center"
    >
      <CircularProgress size={75} />
    </Box>
  )
}

Page.propTypes = {
  match: PropTypes.object,
}

export default Page
